import { render, staticRenderFns } from "./elaboracao.vue?vue&type=template&id=64aa33c9"
import script from "./elaboracao.vue?vue&type=script&lang=js"
export * from "./elaboracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports